import Vue from 'vue';
import 'vue-multiselect/dist/vue-multiselect.min.css';
// tailwind
import './assets/index.css';
import './utils/gtm'

import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en' // lang i18n
import './assets/element-variables.scss'
// import 'element-ui/lib/theme-chalk/index.css'

// set ElementUI lang to EN
Vue.use(ElementUI, { locale })


import './assets/styles/main.sass';
import '@/styles/index.scss' // global css

import App from './App.vue';
import router from './router';

import {formatMoney, projectSettings} from './utils/utils';

import Vuebar from 'vuebar';
import store from './store';

import LoadScript from 'vue-plugin-load-script';
import 'element-closest-polyfill';
import VueLazyload from 'vue-lazyload';

import VueMeta from 'vue-meta';

// import 'beautify-scrollbar/dist/index.css';

// import 'v2-table/dist/index.css';
// import './components/v2-table/style/index.scss';
// import V2Table from './components/v2-table/index';


import config from '../public/harness_config.json';

import auth from '@/auth/authService'

require('./icons.js');

import VueTippy, {TippyComponent} from 'vue-tippy';
Vue.component('tippy', TippyComponent);

import Popover from 'vue-js-popover'
Vue.use(Popover)

import CKEditor from '@ckeditor/ckeditor5-vue';
Vue.use( CKEditor );

import VModal from 'vue-js-modal';

import './assets/element-variables.scss'

Vue.use(VModal, {componentName: 'v-modal', dialog: true});

Vue.use(VueTippy, {
  delay: 100,
  arrow: true,
  arrowType: 'sharp',
  size: 'regular',
  duration: 200,
  maxWidth: 250,
  animation: 'shift-away',

  animateFill: true,
  theme: 'dark',

  // How far the tooltip is from its reference element in pixels
  distance: 10,
});

// Vue.use(V2Table);

Vue.use(VueLazyload);
Vue.use(VueMeta);
Vue.use(Vuebar);
Vue.use(LoadScript);
String.prototype.replaceAll = function(search, replacement) {
  const target = this;
  return target.split(search).join(replacement);
};
const VueScrollTo = require('vue-scrollto');

Vue.use(VueScrollTo, {
//  onDone: (el) => history.pushState(null, null, '#' + el.id)
});

Vue.config.productionTip = false;

const moment = require('moment-timezone');


Vue.filter('shortName', function(name) {
  return (name.fname ? name.fname[0] : '') + (name.lname ? name.lname[0] : '');
});

Vue.filter('webAppLink', (link, charityInfo) => `${config.scheme}://${charityInfo.subdomain}.${config.url}/wv2${link}`);

Vue.filter('newWebAppLink', (link, charityInfo) => `${config.donor_next_scheme}://${charityInfo.subdomain}.${config.donor_next_url}${link}`);

Vue.filter('prepareName', function(name) {
  if (!name) {
    return '';
  }

  return (name.fname ? name.fname + ' ' : '') + (name.lname ? name.lname : '');
});

Vue.filter('dateFormat', function(date, format, fromFormat = false) {
  if (date === null) {
    return moment().format(format);
  }
  if (fromFormat) {
    return moment(date, fromFormat).format(format);
  }
  return moment(date).format(format);
});

Vue.filter('dateFormatTz', function(date, format, fromTz) {
  fromTz = fromTz ? fromTz : 'UTC'
  const zone_name =  moment.tz.guess();
  if (date === null) {
    convertTimezone(null,fromTz, zone_name, format)
  }
  return convertTimezone(date, fromTz, zone_name, format);
});

function convertTimezone(sentDateTime, fromTimezone, toTimezone, format) {
    const currentDateTime =  sentDateTime || new Date()
    const datetime = moment(currentDateTime).tz(fromTimezone);
    const convertedDateTime = datetime.clone().tz(toTimezone);
    return convertedDateTime.format(format)
}

Vue.filter('formatMoney', function(amount, n = 0, x = 3) {
  return formatMoney(amount, n, x);
});

Vue.filter('activityTitle', function(action) {
  switch (action) {
    case 'roundup':
      return 'Round-Up';
    case 'custom':
      return 'Donation';
    case 'recurring':
      return 'Monthly';
    case 'signup':
      return 'NEW Contact';
    case 'monthly_donation_created':
      return 'NEW Monthly Gift';
    case 'roundup_account_created':
      return 'NEW Round-Up Donor';
    default:
      return action;
  }
});

Vue.filter('ucwords', function(str) {
  return (str + '').replace(/^([a-z])|\s+([a-z])/g, function($1) {
    return $1.toUpperCase();
  });
});

Vue.filter('sinceTime', function(timestamp, dateNow) {
  return moment(timestamp).from(dateNow).replace('ago', '');
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const requiresNoAuth = to.matched.some(record => record.meta.requiresNoAuth);
  const noIntercom = to.matched.some(record => record.meta.noIntercom);

  if (noIntercom) {
    document.querySelector('body').classList.add('no-intercom');
  } else {
    document.querySelector('body').classList.remove('no-intercom');
  }

  if (requiresAuth && !auth.isAuthenticated()) {
    next({path: '/admin-login.html', query: {r: to.fullPath}});
  } else if (requiresNoAuth && auth.isAuthenticated()) {
    next('/dashboard');
  }

  if(auth.isAuthenticated() && store.state.auth.activeCharityId) {
    if(store.state.donations.donationsState === 'ready') {
      store.dispatch('donations/fetchAllDonations', {charityId: store.state.auth.activeCharityId});
    }
    if(store.state.donors.donorsState === 'ready') {
      store.dispatch('donors/fetchAllDonors', {charityId: store.state.auth.activeCharityId});
    }
  }

  next();
});
import './components/Settings/settings.sass';
import './components/Fundraise/giving-forms.scss';

new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App),
  created() {
    Vue.loadScript('https://sdk.canva.com/v2/beta/api.js').then(() => {
      (async () => {
        if (window.CanvaButton) {
          this.canva = await window.CanvaButton.initialize({
            apiKey: 'dGVB5fnxxOGP8iyq1a6E--zJ',
          });
        }
      })();
    });
  },
  methods: {
    checkFeature(feature) {
      return projectSettings.isAllowed(feature);
    },
    canAddCampaign() {
      return projectSettings.canAddCampaign();
    },
    isLogin() {
      return auth.isAuthenticated();
    },
  },
  data() {
    return {
      mergeTags: [],
      user: null,
      charity_id: '',
      charities: [],
      canva: null,
    };
  },
});


